import { useState } from 'react';
import cx from 'classnames';

import { getNameInitials } from 'src/utils/nameInitials';

export const EventOrganizer = ({
    label,
    name,
    avatarUrl,
    bordered = true,
}: {
    label: string;
    name: string;
    avatarUrl?: string;
    bordered?: boolean;
}) => {
    const [failedAvatarUrl, setFailedAvatarUrl] = useState<string>();
    const showImage = Boolean(avatarUrl && avatarUrl !== failedAvatarUrl);

    return (
        <div className={cx(bordered && 'border-t border-woodyBrown/15 pt-4')}>
            <p className="mb-2 text-sm font-medium text-woodyBrown/70">
                {label}
            </p>
            <div className="flex items-center gap-3">
                {showImage ? (
                    <img
                        src={avatarUrl}
                        alt=""
                        className="h-10 w-10 flex-shrink-0 rounded-full object-cover"
                        onError={() => setFailedAvatarUrl(avatarUrl)}
                    />
                ) : (
                    <span
                        className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-woodyBrown text-sm font-semibold uppercase text-lightPeach"
                        aria-hidden="true"
                    >
                        {getNameInitials(name)}
                    </span>
                )}
                <span className="font-medium">{name}</span>
            </div>
        </div>
    );
};
